module.exports = __webpack_public_path__ + "img/coke.c9a41a8a.jpg";